import type { FaireProductEntity } from "../../entity_types/product";

export const p_5m6r2q2e3g: FaireProductEntity = {
  token: "p_5m6r2q2e3g",
  type: "product",
  name: "Grateful Dead Stealie Blue Dancing Bear Build Brick Kit",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/a72a1a21aef3da3268fa994bf766b4d48087aa3d6b4c46d6c46062984e750f5e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ae0d07dcbf1dfb3145a0157f1d1343ec8d9dc5a64ae57bd93077382cb043643.jpeg",
    "https://cdn.faire.com/fastly/927bd673cabb625bc8b2f5bf564e351ecd29d2decf03641df83944da217dad71.png",
    "https://cdn.faire.com/fastly/3c129d3345410ea51f4861f403b21b71fe6cdf6bf6c5d7359fc47339c73017d0.jpeg",
    "https://cdn.faire.com/fastly/b372f1f9df3299f3ad0a9be0c08f423cd6d1f14aa0ae637a27a5851e6e5aa264.jpeg",
    "https://cdn.faire.com/fastly/d0427ea30dbe28b62bce58d132218beb925b721ac1a28e72f5dc8a775f333972.jpeg",
    "https://cdn.faire.com/fastly/d93376d4d4175e7d052a1a3bfc2d328292bc6b3448baed75ca39e04fe05f74e3.png",
    "https://cdn.faire.com/fastly/dfbe9ae62eb26c0162d010a6bd93c3bf1caa7f9d7dc1034d320b490d12be24a8.png",
    "https://cdn.faire.com/fastly/599db9b03299be8b4fbbff64a81dda2680144e5f275bce083325d01d455b3f09.jpeg",
    "https://cdn.faire.com/fastly/bc93eda5d828f44510c2ee20d57fd71b32f60c8cf3ed7a41ddf64c388168484a.jpeg",
  ],
  priceDollars: 16.54,
  description:
    "OFFICIALLY LICENSED GRATEFUL DEAD COLLECTIBLE: Build the iconic Stealie Blue Dancing Bear from 387 precision interlocking bricks with full color step-by-step instructions included\n\nFULLY POSABLE DESIGN: Movable arms, legs, and head let you pose and display your Dancing Bear in countless positions — not just a static model, a dynamic desk or shelf piece\n\nCOMPLETE KIT INCLUDES: 387 bricks sorted in numbered bags, full color printed instruction booklet, bonus brick-built concert ticket replica (Winterland Ballroom, Dec 31, 1978)\n\nSECRET BACK COMPARTMENT: Hidden storage built into the bear adds a fun surprise element — a perfect gift for Deadheads, music lovers, and brick building fans ages 8 and up\n\nPREMIUM BRICK QUALITY: BrickCraft bricks are precision-molded for a secure, satisfying click every time — designed, manufactured, and packaged by our small team in the USA",
  tags: [],
  msrpDollars: 39.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:33:31.727Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
